/*
Queto file contiene le estensioni per le funzioni presenti in ListingHelper.js, in modo da poter definire comportamenti diversi nel proprio progetto.
Sovrascrivere questo file nel progetto figlio ed implementare le proprie estensioni.*/
import { defineMessages, useIntl } from 'react-intl';
import { viewDate } from 'design-comuni-plone-theme/helpers';

const getCalendarDate_extend = (item) => {
  let date = null;
  const intl = useIntl();
  const effective = item.effective && (
    <span>{viewDate(intl.locale, item.effective, 'll')}</span>
  );
  switch (item['@type']) {
    case 'ExternalNews':
      date = effective;
      break;
    case 'ComunicatoStampa':
    case 'InvitoStampa':
      date = item.effective && (
        <span>{viewDate(intl.locale, item.effective, 'lll')}</span>
      );
      break;
    default:
      //  date = null; //old
      date = effective; // per tutti i tipi di contenuto ritornerà la data di pubblicazione
  }
  return date;
};

const getEventRecurrenceMore_extend = (item, isEditMode) => {
  let ret = null;
  return ret;
};
export { getCalendarDate_extend, getEventRecurrenceMore_extend };
